import React from "react";
import {
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
  Stack
} from "@mui/material";
import { withStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import ErrorIcon from "@mui/icons-material/Error";

const styles = {
  root: {
    "& div.Mui-disabled": {
      background: "#dddddd70",
    },
    "& input:disabled": {
      "-webkit-text-fill-color": "black",
      cursor: "not-allowed",
    },
  },
};

function CustomInputSameRow({
  label,
  labelRightComponent,
  sicon, // prefix Icon
  eicon, // postfix Icon
  description = null,
  change,
  placeholder,
  size = "small",
  type = "text",
  pattern,
  labelSize,
  maxDate,
  minDate,
  helperText,
  error = null,
  disabled = false,
  readOnly = false,
  maxLength = 200,
  boxProps,
  required,
  marginBottom = 3,
  marginTop = 1,
  onNextLine,
  ...props
}) {
  return (
    <Box {...boxProps} mb={marginBottom} mt={marginTop}>
      <Stack direction={onNextLine ? "column" : "row"} justifyContent={"space-between"} alignItems={'left'}>
        <InputLabel style={{ fontSize: labelSize }}>
          {label}
          {required ? (
            <Typography variant="small" color="error">
              *
            </Typography>
          ) : null}
        </InputLabel>
        <InputLabel>{labelRightComponent}</InputLabel>
   
      {description ? (
        <Typography>{description}</Typography>
      ) : (
        <TextField
          {...props}
          disabled={disabled}
          type={type}
          size={size}
          fullWidth
          placeholder={placeholder}
          {...change}
          InputProps={{
            inputProps: {
              maxLength: maxLength,
              pattern: pattern,
              max: maxDate,
              min: minDate,
              step: "any",
            },
            readOnly: readOnly,
            endAdornment:
              error && props?.id !== "password" && (
                <ErrorIcon color="error" />
              ) || eicon && (
                <InputAdornment position="end" >{eicon}</InputAdornment>
              ),
            startAdornment: sicon ? (
              <InputAdornment position="start">{sicon}</InputAdornment>
            ) : null,
          }}
          {...(error && { error: true, helperText: error })}
        />
      )}
         </Stack>
    </Box>
  );
}

export default withStyles(styles)(CustomInputSameRow);
